module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../../../../../node_modules/happypack/loader.js?id=jsx!./UploadView.js"));
	}, "UploadCertificatesView");
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy&name=UploadCertificatesView!./src/pages/Shop/Member/Personal/Certificates/Upload/UploadView.js
// module id = 987
// module chunks = 438